import Image from 'next/image';

import doctorPerson from './assets/persona-medica.png';

import { cn } from '@/utils/cn-tw-merge';

interface PersonaMediaCardProps {
  className?: string;
  imageClassName?: string;
  priority?: boolean;
}

export function PersonaMediaCard({ className, imageClassName, priority }: PersonaMediaCardProps) {
  return (
    <div className={cn('items-end justify-center bg-green-300 rounded-3xl', className)}>
      <Image
        src={doctorPerson}
        alt="Persona médica"
        draggable={false}
        priority={priority}
        className={cn('h-[22.625rem] w-fit', imageClassName)}
      />
    </div>
  );
}
